export const PREVIEW_SPORT = 'mlb';

export const PACKAGE_FEATURES = [
  { icon: 'fas fa-table-cells-large', text: 'All sports unlocked across one account' },
  { icon: 'fas fa-coins', text: 'Monthly credits for per-game prediction unlocks' },
  { icon: 'fas fa-lock-open', text: '1 credit unlock for standard PW Rating games' },
  { icon: 'fas fa-bolt', text: '3 credit unlock for 70%+ PW Rating games' },
  { icon: 'fas fa-chart-line', text: 'Live line movement - open vs. current' },
  { icon: 'fas fa-percentage', text: 'Public betting splits (tickets and money)' },
  { icon: 'fas fa-key', text: 'Key factors for every matchup' },
  { icon: 'fas fa-equals', text: 'Totals O/U record and line movement' }
];

export const CHECKOUT_FEATURES = [
  'New subscribers get 3 days for $1 - your monthly plan price starts after the trial',
  'All sports included in one plan',
  'Credits replenish monthly based on your plan tier',
  'Unlock score predictions, power spreads, and Proven Line values per game',
  'One-time credit top-ups available when needed',
  'Cancel auto-renew anytime from Subscription Management'
];

export const PROPS_FEATURES = [
  { icon: 'fas fa-puzzle-piece', text: 'Props data is available as an optional monthly add-on' },
  { icon: 'fas fa-lock-open', text: 'Unlock predictions only on games you choose' },
  { icon: 'fas fa-gauge-high', text: '3 credits at 70%+ PW Rating, 1 credit for all others' },
];
